import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    render({logged_in, sale_price_code}) {
        if (logged_in && sale_price_code == 'first-time-buyer') {
            return (
                <discount-message>
                    <p class='sale-msg'>
                        You’re eligible for a first-time Karma Coin purchase discount!
                        Buy today and receive an additional 10% off your selected package!
                    </p>
                </discount-message>
            );
        }

        return (
            <discount-message />
        );
    }
}

const mapStateToProps = (state) => ({
    logged_in: state.user && state.user.logged_in,
    sale_price_code: state['karmacoin-store'].packages && state['karmacoin-store'].packages.standard[0].sale_price_code,
});

export default connect(mapStateToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/karmacoin-store/discount-message.js